import React from 'react'
import classNames from 'classnames'
import { Link } from 'gatsby'
import xealGradient from 'src/images/logos/xealGradient.svg'
import xealWhite from 'src/images/logos/xealWhite.svg'
import { useWindowSize } from '@uidotdev/usehooks'

import Modal from '../Modal'

import * as styles from './desktopNav.module.scss'

// import TalkToASpecialist from 'src/components/forms/SF/SF_TalkToSpecialist.js'

import headerLinks from 'src/components/globals/headerLinks'

import NavDropdown from '../NavDropdown'
import TalkToSpecialist2 from '../../forms/Iframe/TalkToSpecialist2'

export default function DesktopNav({ theme, className }) {
  return (
    <div
      className={classNames(
        styles[`theme_${theme}`],
        styles.desktop,
        className
      )}
    >
      <div className={styles.logoWrap}>
        <Link to="/">
          <picture>
            {theme === 'dark' && (
              <source srcSet={xealWhite} width="80" height="36" />
            )}

            {theme === 'light' && (
              <source
                srcSet={xealGradient}
                media="(max-width:480px)"
                width="80"
                height="36"
              />
            )}

            <img src={xealGradient} alt="Xeal" height="44" width="90" />
          </picture>
        </Link>
      </div>

      <nav className={styles.nav}>
        <NavLinks theme={theme} />
        <NavCta theme={theme} />
      </nav>
    </div>
  )
}

const NavLinks = ({ theme }) => (
  <ul className={styles.navLinks}>
    {headerLinks.nav.map(({ text, to, nav }) =>
      nav ? (
        <NavDropdown
          offset={29}
          offsetCross={40}
          nav={nav}
          text={text}
          theme={theme === 'dark' ? 'none' : 'noneD'}
          key={text}
        />
      ) : (
        <li key={text}>
          <Link to={to} activeClassName={styles.active}>
            {text}

            {text === 'Technology' && (
              <span className={styles.patented}>PATENTED</span>
            )}
          </Link>
        </li>
      )
    )}
  </ul>
)

const NavCta = ({ theme }) => {
  const { width } = useWindowSize()

  return (
    <ul className={styles.navCta}>
      <li className={styles.letsTalkCta}>
        <Modal
          trigger={
            <button>
              <span>
                {headerLinks.cta.talk.text}{' '}
                <svg
                  width="10"
                  height="11"
                  viewBox="0 0 10 11"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.27191 1.11443L9.41197 4.3427C9.41824 4.48721 9.30642 4.60956 9.16236 4.6158C9.01831 4.62205 8.89631 4.50985 8.89004 4.36535L8.7598 1.36325L1.47824 9.33019C1.39437 9.42195 1.24138 9.36669 1.23597 9.24209L1.23015 9.10805C1.22266 8.93528 1.28338 8.76794 1.40019 8.64013L8.38726 0.996491L5.35171 1.12819C5.20766 1.13444 5.08566 1.02223 5.07939 0.877729C5.07312 0.733227 5.18495 0.610877 5.329 0.604627L8.56601 0.46419C8.93971 0.447977 9.2567 0.739511 9.27296 1.11438L9.27191 1.11443Z"
                    fill="#F6F5F1"
                  />
                </svg>
              </span>
            </button>
          }
          title={headerLinks.cta.talk.modal.title}
        >
          {/* <TalkToASpecialist /> */}
          <TalkToSpecialist2 />
        </Modal>
      </li>
      <li>
        <NavDropdown
          {...headerLinks.cta.login}
          theme={theme === 'dark' ? 'light' : 'lightB'}
          offset={21}
          offsetCross={width > 1535 ? 50 : 0}
        />
      </li>
    </ul>
  )
}
